<template>
    <div class="header" :class="additionalClasses">
        <slot name="title"></slot>
        <slot name="button"></slot>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Mixins } from 'vue-property-decorator';
    import { TranslationMixin } from '../../mixins';

    @Component({})
    export default class CoreAccordionHeader extends Mixins(TranslationMixin) {
        @Prop() public additionalClasses: any;
    }
</script>

<style lang="less" scoped>
    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        min-height: 88px;

        & > button {
            display: inline-flex;
            width: 5%;
            padding-right: @spacing-24;
            padding-left: 0;
            color: @info-color-60;
            background: transparent;
            border: 0 solid transparent;

            & i {
                font-size: 0;
            }

            &:focus {
                outline: none;
            }

            &:hover {
                cursor: pointer;
            }
        }
    }
</style>
